import { create } from 'zustand';

export type SortField = 'name' | 'price' | 'stock' | 'articleNumber';
export type SortDirection = 'asc' | 'desc';

export interface CatalogFilters {
  manufacturerId?: number;
  manufacturerName?: string;
  itemGroupId?: number;
  itemGroupName?: string;
  onlyInStock?: boolean;
}

interface CatalogFilterState {
  filters: CatalogFilters;
  viewMode: 'grid' | 'cards';
  searchText: string;
  sortField: SortField;
  sortDirection: SortDirection;
  setManufacturer: (id: number | undefined, name: string | undefined) => void;
  setItemGroup: (id: number | undefined, name: string | undefined) => void;
  setOnlyInStock: (value: boolean) => void;
  clearAll: () => void;
  setViewMode: (mode: 'grid' | 'cards') => void;
  setSearchText: (text: string) => void;
  setSortField: (field: SortField) => void;
}

const EMPTY_FILTERS: CatalogFilters = {};

export const useCatalogFilterStore = create<CatalogFilterState>((set) => ({
  filters: { ...EMPTY_FILTERS },
  viewMode: 'cards',
  searchText: '',
  sortField: 'name',
  sortDirection: 'asc',

  setManufacturer: (id, name) =>
    set((s) => ({
      filters: { ...s.filters, manufacturerId: id, manufacturerName: name },
    })),

  setItemGroup: (id, name) =>
    set((s) => ({
      filters: { ...s.filters, itemGroupId: id, itemGroupName: name },
    })),

  setOnlyInStock: (value) =>
    set((s) => ({
      filters: { ...s.filters, onlyInStock: value },
    })),

  clearAll: () => set({ filters: { ...EMPTY_FILTERS } }),

  setViewMode: (mode) => set({ viewMode: mode }),

  setSearchText: (text) => set({ searchText: text }),

  setSortField: (field) =>
    set((s) => ({
      sortField: field,
      sortDirection:
        s.sortField === field
          ? s.sortDirection === 'asc'
            ? 'desc'
            : 'asc'
          : 'asc',
    })),
}));
